import { render, staticRenderFns } from "./TrainerPermissionsListItem.vue?vue&type=template&id=607d8e6e&scoped=true"
import script from "./TrainerPermissionsListItem.vue?vue&type=script&lang=js"
export * from "./TrainerPermissionsListItem.vue?vue&type=script&lang=js"
import style0 from "./TrainerPermissionsListItem.vue?vue&type=style&index=0&id=607d8e6e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "607d8e6e",
  null
  
)

export default component.exports